import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_DATA} from '../../../api';
import $ from "jquery";
import cogoToast from "cogo-toast";
import moment from "moment";
import {capitalize} from "../../../utils/capitalize";
import {getPreSignedUrl, uploadPhoto, investment, payout, getLoanReport, liveAccount} from "../../../api/app";
import 'react-quill/dist/quill.snow.css';
import networks from "../../../data/networks.json";
import formatNumber from "../../../utils/formatNumber";

const Loan = () => {

    document.title = "Loan";

    const token = localStorage.getItem('jwtToken');
    const [editForm, setEditForm] = useState(false);
    const [editId, setEditId] = useState(0);
    const [id, setId] = useState(null);
    const [type, setType] = useState(null);
    const [stateReady, setStateReady] = useState(false);
    const [reset, setReset] = useState(new Date().getTime());
    const [network, setNetwork] = useState([]);

    useEffect(() => {
        liveAccount().then((response) => {
            if(!response.error) {
                $('#live-balance').text(formatNumber(response.payload.balance));
            }
        });
    }, [reset]);

    useEffect(() => {
        getLoanReport().then((response) => {
            if(!response.error) {
                $('#total-loan').text(formatNumber(response.payload.total.count, "digit"));
                $('#total-loan-amount').text(`Amount: K${formatNumber(response.payload.total.amount, "digit")}`);

                $('#total-active').text(formatNumber(response.payload.active.count, "digit"));
                $('#total-active-amount').text(`Amount: K${formatNumber(response.payload.active.amount, "digit")}`);

                $('#total-pending').text(formatNumber(response.payload.pending.count, "digit"));
                $('#total-pending-amount').text(`Amount: K${formatNumber(response.payload.pending.amount, "digit")}`);

                $('#total-disbursed-amount').text(`Amount: K${formatNumber(response.payload.disbursement.total, "digit")}`);
                $('#total-disbursed').text(formatNumber(response.payload.disbursement.count, "digit"));
            }
        });
    }, [reset]);

    useEffect(() => {
        let table = $('#fund').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Loan Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "loan",
                        fieldname: "reg_number",
                        pageSize: data.start,
                        format: 'json',
                        populate: [
                            {
                                path: "user",
                                model: "user"
                            }
                        ],
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];

                        res.data.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data?.user?.name ? capitalize(data?.user?.name) : `<span class="tx-danger">No Data</span>`;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return `K${formatNumber(data.amount)}`;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return capitalize(data?.business_type);
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return {
                            "pending" : `<span class="badge badge-secondary tx-white">Pending</span>`,
                            "active" : `<span class="badge badge-success tx-white">Approved</span>`,
                            "rejected" : `<span class="badge badge-danger tx-white">Rejection</span>`
                        }[data.status];
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only">${data.approved ? `<span class="nav-link approve-fund">--- No Action ---</span>`  : `<a href="#" class="nav-link approve-fund"><i class="fa fa-check"></i> Approve</a>` }</nav>`
                    },
                    "targets": 5
                }
            ]
        });

        $('#fund tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        table.on('click', '.approve-fund', function(e) {
            e.preventDefault();

            let extract_td = table.row($(this).closest('tr')).data();
            setId(extract_td.raw._id);
            setType("loan");
            $('#disbursement-amount').val(extract_td.raw.amount);
            $('#payout_form').parsley();

            $("#modalPayout").modal("show");
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Description:</td>' +
                '<td>' +
                `${d.raw.description}` +
                '</td>' +
                '</tr>' +
                '<tr>' +
                '<td>Contact Number:</td>' +
                '<td>' +
                `${d.raw.user.mobile_number}` +
                '</td>' +
                '</tr>' +
                '<td>Reg Number:</td>' +
                '<td>' +
                `${d.raw.req_number}` +
                '</td>' +
                '</tr>' +
                '<tr>' +
                '<td>Date:</td>' +
                '<td>' +
                `${moment(d.raw?.createdAt).format("Do MMM, YYYY")}` +
                '</td>' +
                '</tr>' +
                '</table>'
            );
        }

        return () => {
            table.destroy();
        }

    }, []);

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const handlePayment = (e) => {
        $("#label-number").text(e.target.value === "momo" ? "Mobile Number" : "Account Number");
        setNetwork(networks.filter((item) => item.type === e.target.value));
        $("#network").val('');
    }

    const handleDisbursement = (e) => {
        e.preventDefault();

        let amount = $('#disbursement-amount').val();
        let email = $('#email').val();

        setStateReady(true);

        let data = {
            id,
            amount,
            email,
            account_number: $('#account-number').val(),
            network: $('#network').val(),
            gateway: $('#gateway').val(),
            doc: type
        };

        payout("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Disbursement successfully sent.", {position: "top-right", hideAfter: 5});
                resetForm("modalPayout", "payout_form");
                reloadTable("fund");
                setReset(new Date().getTime());
            }
        });
    }

    const reloadTable = (id) => {
        $(`#${id}`).DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Fund</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Loan</h4>
                    </div>
                    <div className="media align-items-center">
                        <img src="assets/img/logo.svg" className="ht-40 img-fluid" alt="logo"/>
                        <div className="media-body mg-l-10 my-auto">
                            <h6 className="tx-10 tx-lg-12 tx-medium tx-uppercase tx-spacing-1 tx-gray-800 mg-b-5">Live Account <span className="tx-normal tx-color-03">(ZMW)</span></h6>
                            <div className="d-flex align-items-baseline">
                                <h2 className="tx-13 tx-lg-24 tx-bold tx-rubik tx-spacing--2 lh-2 mg-b-0" id="live-balance">0</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-sm-6 col-lg-3">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Loan</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-loan" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="total-loan-amount" className="tx-12 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-success tx-semibold mg-b-8">Total Active</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-active" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="total-active-amount" className="tx-12 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-danger tx-semibold mg-b-8">Total Pending</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-pending" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="total-pending-amount" className="tx-12 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-gray-800 tx-semibold mg-b-8">Total Disbursement</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-disbursed" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="total-disbursed-amount" className="tx-12 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-md-12 mg-t-10">
                        <div className="card card-crypto">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Loan List</h6>
                                <div className="d-flex tx-18">
                                   <a href="#" onClick={(e) => {
                                        e.preventDefault(); $('#fund').DataTable().ajax.reload();
                                        setReset(new Date().getTime());
                                    }} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <div id="general" className="tab-pane fade active show">
                                    <table id="fund" className="table">
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th className="wd-20p">Name</th>
                                            <th className="wd-20p">Amount</th>
                                            <th className="wd-20p">Type</th>
                                            <th className="wd-20p">Status</th>
                                            <th className="wd-20p">Action</th>
                                        </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalPayout" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalPayout", "payout_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit Payout" : "Add Payout"}</h4><p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Create"} payout information.</p></div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="payout_form" className="parsley-style-1" onSubmit={handleDisbursement.bind()}>
                                    <div id="emailWrapper" className="form-group parsley-input">
                                        <label>Email Address</label>
                                        <input id="email" type="email" className="form-control"
                                               placeholder="Enter email address"
                                               autoComplete="none"
                                               data-parsley-class-handler="#emailWrapper"
                                               required
                                        />
                                    </div>

                                    <div id="typeWrapper" className="form-group parsley-input">
                                        <label>Mode of Payment<span className="tx-danger">*</span></label>
                                        <select className="custom-select" id="gateway" required onChange={handlePayment.bind()}>
                                            <option value="" disabled selected>Select</option>
                                            <option value="momo">Mobile Money</option>
                                            <option value="bank">Bank</option>
                                        </select>
                                    </div>

                                    <div id="typeWrapper" className="form-group parsley-input">
                                        <label>Network<span className="tx-danger">*</span></label>
                                        <select className="custom-select" id="network" required>
                                            <option value="" disabled selected>Select</option>
                                            {network.slice().sort((a, b) => a.name.localeCompare(b.name)).map((item, index) => (
                                                <option key={index} value={item.value}>{item.name}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div id="accountNumberWrapper" className="form-group parsley-input">
                                        <label id="label-number">Account Number</label>
                                        <input id="account-number" type="number" className="form-control"
                                               placeholder="Enter number"
                                               autoComplete="none"
                                               data-parsley-class-handler="#accountNumberWrapper"
                                               required
                                        />
                                    </div>

                                    <div id="amountWrapper" className="form-group parsley-input">
                                        <label>Amount<span className="tx-danger">*</span></label>
                                        <input id="disbursement-amount" type="number" className="form-control"
                                               placeholder="Enter amount"
                                               autoComplete="none"
                                               step="0.01"
                                               data-parsley-class-handler="#amountWrapper"
                                               required/>
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-success btn-block"><span
                                        className="spinner-border spinner-border-sm mg-r-10" role="status"
                                        aria-hidden="true"/>Please Wait</button> : editForm ?
                                        <button className="btn btn-success btn-block">Update Payout</button> :
                                        <button className="btn btn-success btn-block">Add Payout</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Loan;
